import { useContext } from 'react'

import DaiContext from 'contexts/DaiContext'

const useDai = () => {
  const context = useContext(DaiContext)

  if (context === undefined) {
    throw new Error('useDai must be used within a DaiContext.Provider')
  }

  return {
    expandedDaiActivityAnalysis: context.expandedDaiActivityAnalysis,
    setExpandedDaiActivityAnalysis: context.setExpandedDaiActivityAnalysis,
  }
}

export default useDai
